module.exports = __webpack_public_path__ + "img/brave-2.abc1bdc6.webp";